import { ENDPOINT } from '~/api/constants';
import { ETADeliveryMethodType } from '~/api/ETADeliveryMethodType';
import { RequestAPI } from '~/api/Requests';

import {
  ETAProviderCalculation,
  ETAResponse,
  GetETAV2Props,
  GetETAV3Props,
} from './ETA';
import { GetETAV3Response } from './v3/ETA';

export interface ETARequestsInterface {
  getETA(data: {
    pos: string;
    seller: string;
    deliveryMethod?: ETADeliveryMethodType;
    signal?: AbortController['signal'];
  }): Promise<ETAResponse>;

  getETAV2(data: GetETAV2Props): Promise<{
    data: ETAProviderCalculation;
  }>;

  getETAV3(data: GetETAV3Props): Promise<{
    data: GetETAV3Response;
  }>;

  getETASlot(data: {
    pos: string;
    seller: string;
    scheduleSlotId?: string;
    deliverySlotId?: string;
    createdAt?: number;
    currentDate?: number;
  }): Promise<ETAResponse>;
}

export const ETARequests: ETARequestsInterface = {
  getETA: (data) => {
    const { signal, ...restData } = data;

    return RequestAPI.get(ENDPOINT.eta.get, restData, { signal });
  },
  getETAV2: (data) => {
    const { signal, ...restData } = data;

    return RequestAPI.get(ENDPOINT.eta.getV2, restData, { signal });
  },
  getETAV3: (data) => {
    const { signal, ...restData } = data;

    return RequestAPI.get(ENDPOINT.eta.getV3, restData, { signal });
  },
  getETASlot: (data) => RequestAPI.get(ENDPOINT.eta.getSlot, data),
};
